import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const DEFAULT_TITLE = "proste.menu";
const DEFAULT_IMAGE = "https://proste.menu/og-image.jpg";

interface DynamicHeadProps {
  ogTitle?: string | null;
  ogDescription?: string | null;
  ogImage?: string | null;
  companyOgTitle?: string | null;
  companyOgDescription?: string | null;
  companyOgImage?: string | null;
  robots?: string;
  canonical?: string;
}

export const DynamicHead: React.FC<DynamicHeadProps> = ({
  ogTitle,
  ogDescription,
  ogImage,
  companyOgTitle,
  companyOgDescription,
  companyOgImage,
  robots,
  canonical,
}) => {
  const { t } = useTranslation();
  const title = ogTitle || companyOgTitle || DEFAULT_TITLE;
  const description = ogDescription || companyOgDescription || t("siteMetadata.defaultDescription");
  const image = ogImage || companyOgImage || DEFAULT_IMAGE;
  const canonicalUrl = canonical || window.location.href;

  return (
    <Helmet>
      <html lang="pl" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {robots && <meta name="robots" content={robots} />}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pl_PL" />
      <meta property="og:site_name" content="proste.menu" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};
